export class JobalertCreateHandler {
    resolve = null;
    reject = null;
    popup = null;

    constructor(popup) {
        this.popup = popup;
    }

    createJobalert(actionUri, companyId) {
        return new Promise(async (resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;

            try {
                const data = new FormData();
                data.set('popupRequest', 'true');
                data.set('returnUri', window.location.href);
                data.set('companyId', companyId)

                const response = await fetch(actionUri, {
                    method: 'POST',
                    header: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                    body: data,
                });

                this.popup.setContent(await response.text());
                this.popup.open();

                if(this.popup.contentElement.getElementsByClassName('g-recaptcha').length > 0){
                    window.grecaptcha.enterprise.render(this.popup.contentElement.getElementsByClassName('g-recaptcha')[0]);
                }
            } catch (error) {
                this.fail(error);
            }
        });
    }

    finish(success) {
        this.resolve(success);
        this.popup.close();
    }

    fail(error) {
        this.reject(error);
        this.popup.close();
    }
}
